import { render, staticRenderFns } from "./NewLabel.vue?vue&type=template&id=3fd079e2&scoped=true&"
import script from "./NewLabel.vue?vue&type=script&lang=js&"
export * from "./NewLabel.vue?vue&type=script&lang=js&"
import style0 from "./NewLabel.vue?vue&type=style&index=0&id=3fd079e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd079e2",
  null
  
)

export default component.exports